import { setLoading } from "../generalActions/mainActions";
import { setItems, setTableParams } from "../generalActions/listActions";
import { inHouseService } from "../../../jwt/_services/todoFluye/inHouseService";

export const search = (pageIndex, pageSize, currentPage, filter) => ( dispatch ) => {
    dispatch(setLoading(true))

    inHouseService.search(pageIndex, pageSize, filter)
        .then(result => {
            if (!result)
                return

            dispatch(setItems(result.data))
            dispatch(setTableParams(pageSize, pageIndex, result?.total, currentPage))
        })
        .finally(() => dispatch(setLoading(false)))
}